<template>
    <div>
        <!--导航栏-->
        <van-nav-bar
                title="通道进件选择"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏-->
        <div style="margin-top: 1.5rem">
            <van-cell title="A通道" value="合利宝" is-link to="/helipay" />
            <van-cell title="B通道" value="联动支付" is-link to="/umpayer" />
            <van-cell title="C通道" value="乐刷支付" is-link to="/leshuazf" />
            <van-cell title="D通道" value="银联支付" is-link to="/union"/>
        </div>
    </div>
</template>

<script>
    //进件通道选择
    export default {
        name: "Gangway",
        methods:{
            //左侧返回
            onClickLeft(){
                this.$router.push("/");
            }
        }
    }
</script>

<style scoped>

</style>